/** Site-wide SEO defaults for FAIR (canonical: https://fair.store). */

export const FAIR_SITE_URL = 'https://fair.store'

export const FAIR_SEO_DEFAULT_LANG = 'en'

export const FAIR_SEO_DEFAULT_TITLE = 'FAIR — Discover your style'

export const FAIR_SEO_DEFAULT_DESCRIPTION =
  'Discover your style with FAIR. Search fashion by text or photo, explore capsules, brands, and AI-styled picks — find what you love faster.'

export const FAIR_SEO_OG_IMAGE_PATH = '/og-home.jpg'

export function fairAbsoluteUrl(path = '/'): string {
  if (/^https?:\/\//i.test(path)) {
    return path
  }
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${FAIR_SITE_URL}${normalized}`
}

export function fairOgImageUrl(): string {
  return fairAbsoluteUrl(FAIR_SEO_OG_IMAGE_PATH)
}
